import {
    CollectionResponseType,
    GridResourceCollectionInterface
} from "../../store/interfaces/GridResourceCollectionInterface";
import {apiDayOffAskAsMemberPost, apiDaysOffMineGet, DayOffCreateFromMemberInput, DayOffOutput} from "../../generated";
import {action, observable} from "mobx";
import UiBus from "../../store/service/UiBus";
import {handleFormSubmit} from "../../utils/form/handleFormSubmit";
import {v4} from 'uuid';

export type NewDayOffForm = Pick<DayOffCreateFromMemberInput, 'reason' | 'date'>

export class DaysOffEmployeeStore implements GridResourceCollectionInterface<DayOffOutput> {
    @observable collectionResponse: CollectionResponseType<DayOffOutput> | null = null;
    @observable isLoading = false;
    @observable isNewDayOffModalOpen = false;

    constructor(private uiBus: UiBus) {
    }

    @action fetchCollection(query): void {
        this.isLoading = true;
        apiDaysOffMineGet()
            .then(action(response => {
                this.collectionResponse = {
                    "hydra:member": response,
                    "hydra:search": null,
                    "hydra:totalItems": response.length,
                    "hydra:view": null,
                }
            }))
            .finally(action(() => {
                this.isLoading = false;
            }))
            .catch((error) => {
                this.uiBus.notify("Something went wrong", "warning");
            })
    }

    @action toggleLoading(): void {
        this.isLoading = !this.isLoading;
    }

    @action closeModal() {
        this.isNewDayOffModalOpen = false;
    }

    @action openModal() {
        this.isNewDayOffModalOpen = true;
    }

    @action async submitNewDayOff(form: NewDayOffForm) {
        const response = await handleFormSubmit(apiDayOffAskAsMemberPost({
            id: v4(),
            ...form,
        }))
        if (response.errors) {
            return response.errors;
        }
        this.fetchCollection({})
        this.closeModal();
    }
}